import { Button } from "@/components/ui/button";
import moment from "moment";

export function PrtReportingSummaryHandler({ currentExport, data, dataSave, exportToExcel }) {
  if (currentExport == "prt reporting") {
    const exportData = dataSave.part_request_tickets
      .filter((obj) => {
        if (data.date_from && data.date_to) {
          return moment(obj.created_at).isBetween(
            data.date_from,
            data.date_to,
          );
        } else {
          return true;
        }
      })
      .filter((obj) => {
        if (data.customer_id) {
          return obj.service_order_ticket.customer_id == data.customer_id;
        } else {
          return true;
        }
      })
      .map((obj) => {
        const partTransfers = obj.part_transfers.sort((a, b) => {
          return moment(a.created_at).diff(moment(b.created_at));
        });
        const partReceiveds = obj.part_receiveds.sort((a, b) => {
          return moment(a.created_at).diff(moment(b.created_at));
        });
        const firstDeliverTime = partTransfers[0]?.created_at;
        const lastDeliverTime =
          partTransfers[partTransfers.length - 1]?.created_at;
        const lastReceivedTime =
          partReceiveds[partReceiveds.length - 1]?.created_at;
        const deliveryTime = moment.duration(
          moment(lastReceivedTime).diff(moment(firstDeliverTime)),
        );
        const deliveryTimeHours = Math.floor(deliveryTime.asHours());
        const deliveryTimeMinutes =
          Math.floor(deliveryTime.asMinutes()) - deliveryTimeHours * 60;
        const deliveryTimeSeconds =
          Math.floor(deliveryTime.asSeconds()) -
          deliveryTimeHours * 60 * 60 -
          deliveryTimeMinutes * 60;
        const deliveryTimeFormat =
          deliveryTimeHours +
          ":" +
          deliveryTimeMinutes +
          ":" +
          deliveryTimeSeconds;

        const returnedPartTime = obj.prt_status_works.find(
          (sw) => sw.status_work_code === "PRT",
        )?.created_at;
        const returnTime = moment.duration(
          moment(returnedPartTime).diff(moment(lastReceivedTime)),
        );
        const returnTimeHours = Math.floor(returnTime.asHours());
        const returnTimeMinutes =
          Math.floor(returnTime.asMinutes()) - returnTimeHours * 60;
        const returnTimeSeconds =
          Math.floor(returnTime.asSeconds()) -
          returnTimeHours * 60 * 60 -
          returnTimeMinutes * 60;
        const returnTimeFormat =
          returnTimeHours + ":" + returnTimeMinutes + ":" + returnTimeSeconds;

        const requestPartTime = obj.prt_status_works.find(
          (sw) => sw.status_work_code === "PRO",
        )?.created_at;
        const requestTime = moment.duration(
          moment(lastDeliverTime).diff(moment(requestPartTime)),
        );
        const requestTimeHours = Math.floor(requestTime.asHours());
        const requestTimeMinutes =
          Math.floor(requestTime.asMinutes()) - requestTimeHours * 60;
        const requestTimeSeconds =
          Math.floor(requestTime.asSeconds()) -
          requestTimeHours * 60 * 60 -
          requestTimeMinutes * 60;
        const requestTimeFormat =
          requestTimeHours +
          ":" +
          requestTimeMinutes +
          ":" +
          requestTimeSeconds;

        return {
          "PRT No": obj.pr_ticket_no,
          "SOT No": obj.service_order_ticket?.so_ticket_no,
          "SE Code": obj.service_order_ticket?.on_duty_service_engineer?.code,
          "LOG Code": obj.prt_status_works.find(
            (sw) => sw.status_work_code === "PRD",
          )?.updated_by
            ? obj.prt_status_works.find((sw) => sw.status_work_code === "PRD")
                ?.updated_by
            : "-",
          "Open Time": obj.prt_status_works.find(
            (sw) => sw.status_work_code === "PRO",
          )?.created_at
            ? moment(
                obj.prt_status_works.find(
                  (sw) => sw.status_work_code === "PRO",
                )?.created_at,
              )
                .subtract(7, "hours")
                .format("YYYY-MM-DD HH:mm:ss")
            : "-",
          "Preparation Time": requestTime ? requestTimeFormat : "-",
          "Delivery Time": deliveryTime > 0 ? deliveryTimeFormat : "-",
          "Return Time": returnTime > 0 ? returnTimeFormat : "-",
          "Requested Part (Part Name | Part Number)": obj.part_requests
            .map((pr) => {
              return (
                (pr?.part_details?.name || "-") +
                " | " +
                (pr?.part_details?.part_number || "-")
              );
            })
            .join(";"),
        };
      });

    return (
      <Button
        variant="primary"
        onClick={() =>
          exportToExcel(
            exportData,
            `prt_summary_${moment().format("hhmm_DDMMYYYY")}.xlsx`,
          )
        }
      >
        Submit
      </Button>
    );
  }
  return null;
}
